import { getDownloadURL, getStorage, ref, uploadBytes } from "firebase/storage";

// Firebase 스토리지에 이미지 업로드하는 함수
export const uploadFileToStorage = async (
  path: string,
  file: File
): Promise<string> => {
  const storage = getStorage();
  const storageRef = ref(storage, path); // 경로를 동적으로 받음

  try {
    // 파일을 Firebase 스토리지에 업로드
    await uploadBytes(storageRef, file);

    // 업로드된 파일의 다운로드 URL 가져오기
    const downloadUrl = await getDownloadURL(storageRef);
    return downloadUrl; // 업로드 후 URL 반환
  } catch (error) {
    console.error("Error uploading file to Firebase Storage:", error);
    throw new Error("Image upload failed");
  }
};
